// WebGLPinDemo.tsx - Full-screen WebGL pin art demo page
import React from 'react';
import styled from 'styled-components';
import WebGLPinArt from '../components/PretextChart/WebGLPinArt';

const PageContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #0a0a0f;
  overflow: hidden;
  
  /* Prevent pull-to-refresh and overscroll */
  overscroll-behavior: none;
  touch-action: none;
`;

const Title = styled.h1`
  position: absolute;
  top: 15px;
  left: 50%;
  transform: translateX(-50%);
  color: #00bfff;
  font-family: 'Inter', sans-serif;
  font-size: 18px;
  font-weight: 700;
  margin: 0;
  z-index: 10;
  text-shadow: 0 2px 10px rgba(0, 191, 255, 0.3);
`;

const WebGLPinDemo: React.FC = () => {
  return (
    <PageContainer>
      <Title>⚡ WebGL Pin Art</Title>
      <WebGLPinArt gridSpacing={8.0} />
    </PageContainer>
  );
};

export default WebGLPinDemo;
